export default __webpack_public_path__ + "static/media/on-20.eb905a7a.png";